import axios from 'axios';
import { NotificationListResponse } from '../types/notification';

export type NotificationCategory = 'student' | 'company' | 'handled';

export interface GetNotificationsQuery {
  is_read?:  boolean;
  category?: NotificationCategory;
  page?:     number;
  limit?:    number;
}

export const eventNotificationService = {
  /** NTF-01: 通知一覧取得 */
  getNotifications: async (query: GetNotificationsQuery = {}): Promise<NotificationListResponse> => {
    const params = new URLSearchParams();
    if (query.is_read  !== undefined) params.append('is_read',  String(query.is_read));
    if (query.category !== undefined) params.append('category', query.category);
    if (query.page)                   params.append('page',     String(query.page));
    if (query.limit)                  params.append('limit',    String(query.limit));

    const res = await axios.get(`/api/notifications?${params.toString()}`, {
      withCredentials: true,
    });
    return res.data.data;
  },

  /** NTF-02: 個別既読更新 */
  markAsRead: async (id: number): Promise<{ id: number; is_read: boolean }> => {
    const res = await axios.patch(`/api/notifications/${id}/read`, {}, {
      withCredentials: true,
    });
    return res.data.data;
  },

  /** NTF-03: 全件既読 */
  markAllAsRead: async (): Promise<void> => {
    await axios.patch('/api/notifications/read-all', {}, { withCredentials: true });
  },

  /** NTF-04: 未読数取得 */
  getUnreadCount: async (): Promise<number> => {
    const res = await axios.get('/api/notifications/unread-count', {
      withCredentials: true,
    });
    return res.data.data.unread_count as number;
  },

  /** NTF-05: 個別削除 */
  deleteNotification: async (id: number): Promise<void> => {
    await axios.delete(`/api/notifications/${id}`, { withCredentials: true });
  },

  /** NTF-06: 既読通知を一括削除（未対応のみ） */
  deleteReadNotifications: async (): Promise<{ deleted_count: number }> => {
    const res = await axios.delete('/api/notifications/read-all', { withCredentials: true });
    return res.data.data as { deleted_count: number };
  },

  /** NTF-07: 対応済みトグル */
  toggleHandled: async (id: number): Promise<{ id: number; is_handled: boolean; is_read: boolean }> => {
    const res = await axios.patch(`/api/notifications/${id}/handled`, {}, { withCredentials: true });
    return res.data.data;
  },

  /** NTF-08: 対応済み通知を一括削除 */
  deleteHandledNotifications: async (): Promise<{ deleted_count: number }> => {
    const res = await axios.delete('/api/notifications/handled-all', { withCredentials: true });
    return res.data.data as { deleted_count: number };
  },
};

/** 企業ロール向け通知 API（/api/company/notifications） */
export const companyNotificationService = {
  getNotifications: async (query: GetNotificationsQuery = {}): Promise<NotificationListResponse> => {
    const params = new URLSearchParams();
    if (query.is_read !== undefined) params.append('is_read', String(query.is_read));
    if (query.page)                  params.append('page',    String(query.page));
    if (query.limit)                 params.append('limit',   String(query.limit));

    const res = await axios.get(`/api/company/notifications?${params.toString()}`, {
      withCredentials: true,
    });
    return res.data.data;
  },

  markAsRead: async (id: number): Promise<{ id: number; is_read: boolean }> => {
    const res = await axios.patch(`/api/company/notifications/${id}/read`, {}, {
      withCredentials: true,
    });
    return res.data.data;
  },

  markAllAsRead: async (): Promise<void> => {
    await axios.patch('/api/company/notifications/read-all', {}, { withCredentials: true });
  },

  getUnreadCount: async (): Promise<number> => {
    const res = await axios.get('/api/company/notifications/unread-count', {
      withCredentials: true,
    });
    return res.data.data.unread_count as number;
  },

  deleteNotification: async (id: number): Promise<void> => {
    await axios.delete(`/api/company/notifications/${id}`, { withCredentials: true });
  },

  deleteReadNotifications: async (): Promise<{ deleted_count: number }> => {
    const res = await axios.delete('/api/company/notifications/read-all', { withCredentials: true });
    return res.data.data as { deleted_count: number };
  },

  toggleHandled: async (id: number): Promise<{ id: number; is_handled: boolean; is_read: boolean }> => {
    const res = await axios.patch(`/api/company/notifications/${id}/handled`, {}, { withCredentials: true });
    return res.data.data;
  },

  deleteHandledNotifications: async (): Promise<{ deleted_count: number }> => {
    const res = await axios.delete('/api/company/notifications/handled-all', { withCredentials: true });
    return res.data.data as { deleted_count: number };
  },
};
